import type { AuthProps } from '../types/auth';
import { fetchAuthSession } from 'aws-amplify/auth';
import { configureAmplify } from '../utils/client';

export const getIdTokenOnClient = async (): Promise<string | undefined> => {
  try {
    const { idToken } = (await fetchAuthSession()).tokens ?? {};

    return idToken?.toString();
  } catch (e) {}

  return undefined;
};

let forcedRefetchOfAuthSession = false;

/**
 * Fetches the auth props on the client.
 * In most cases you'll want to use the `useAuthProps()` hook.
 */
export const fetchAuthPropsOnClient = async (): Promise<AuthProps> => {
  // TODO currently this does not take care of an ongoing impersonation

  await configureAmplify();

  let session = await fetchAuthSession({
    forceRefresh: forcedRefetchOfAuthSession === false,
  });

  forcedRefetchOfAuthSession = true;

  let idToken = session.tokens?.idToken;
  let accessToken = session.tokens?.accessToken;

  if (typeof idToken === 'undefined' || typeof accessToken === 'undefined') {
    return {
      authenticated: false,
      idToken: '',
      accessToken: '',
      impersonated: false,
    };
  }

  return {
    authenticated: !!idToken.payload.email,
    id: session.userSub,
    email: String(idToken.payload.email),
    emailVerified: idToken.payload.email_verified === true,
    idToken: idToken.toString(),
    accessToken: accessToken.toString(),
    impersonated: false,
  };
};
